import type { ReactElement } from 'react';

type IconArrowDownProps = {
  width: number;
  height: number;
};

export default function IconArrowDown(props: IconArrowDownProps): ReactElement {
  const { width, height } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1L6 6L1 1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
